import { render, staticRenderFns } from "./NewProductList1.vue?vue&type=template&id=0f3a7ba0&scoped=true"
import script from "./NewProductList1.vue?vue&type=script&lang=js"
export * from "./NewProductList1.vue?vue&type=script&lang=js"
import style0 from "./NewProductList1.vue?vue&type=style&index=0&id=0f3a7ba0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3a7ba0",
  null
  
)

export default component.exports